import React,{useState,useEffect,useRef} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { MASTERALGORITHM } from '../../../../commons/api';
import { getList, DeleteMasters } from '../../Utils/FormCalls';
import { Button, Tooltip, Input, message, Popconfirm } from 'antd';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import StyledTable from '../../../../commons/styles/table';
import {
  EditOutlined,
  SearchOutlined,
  QuestionCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons';
const APIList = {
  getList: `${MASTERALGORITHM.GET}`,
  delete: `${MASTERALGORITHM.DELETE}`
};
const AlgorithmMastersList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? response : []);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);
  // const viewRecord = (e, record) => {
  //   e.preventDefault();
  //   props.navigate(`/rubus/RbsAnalytics/AlgorithmMasterDetails/${record.Id}`, {
  //     state: { viewTag: true }
  //   });
  // };
  const editRecord = (record) => {
    props.navigate(`/rubus/RbsAnalytics/AlgorithmMasterDetails/${record.Id}`, {
      state: { editTag: true }
    });
  };
  const _deleteById = async (Id) => {
    let response = await DeleteMasters(APIList.delete, Id);
    if (response && response.message) {
      message.success(response.message);
    }
    let responseList = await getList(APIList.getList);
    setDataSource(responseList && Array.isArray(responseList) ? responseList : []);
  };
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
          type='primary'
          danger
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const columns = [
    {
      title: translation('Algorithm Name'),
      dataIndex: 'AlgorithmName',
      key: 'AlgorithmName'
    },
    {
      title: translation('Model Type'),
      dataIndex: 'ModelType',
      key: 'ModelType'
    },
    {
      title: translation('GPU Flag'),
      dataIndex: 'GPUFlag',
      key: 'GPUFlag'
    },
    {
      title: translation('Created By'),
      dataIndex: 'CreatedName',
      key: 'CreatedName',
      ...getColumnSearchProps('CreatedName'),
      sorter: (a, b) => a.CreatedName.length - b.CreatedName.length
    },
    {
      title: translation('Created Time'),
      dataIndex: 'CreatedTime',
      key: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) =>
        a.CreatedTime && b.CreatedTime && a.CreatedTime.localeCompare(b.CreatedTime),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Action'),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            style={{ marginRight: '5px' }}
            type='primary'
            onClick={() => editRecord(record)}
            
          >
            <EditOutlined />
          </Button>
          <Popconfirm
            title={translation('Are you want to delete?')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation('Yes')}
            cancelText={translation('No')}
          >
            <Tooltip title={translation('Delete')}>
              <Button type='primary' >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      )
    }
  ];
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Tooltip title={translation('Click here to add a new Algorithm')}>
            <Button
              onClick={() => props.navigate('/rubus/RbsAnalytics/AlgorithmMasterDetails')}
              type="primary"
              style={{
                marginBottom: 8
              }}
              
            >
              {translation('New')}
            </Button>
          </Tooltip>
        </div>
        <StyledTable size="small"
          theme={themeSettings}
          dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
          columns={columns}
        ></StyledTable>
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect (mapStateToProps)(AlgorithmMastersList);
